<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Google Ads Account
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="ppc-account-id" label="Google Ads Account ID">
          <UiInput v-model="form.google_ads_account_id" placeholder="XXX-XXX-XXXX or 'Needs to be created'" />
        </UiControl>
        <UiControl id="ppc-login-email" label="Existing Google Ads Login Email">
          <UiInput v-model="form.existing_google_ads_email" type="email" placeholder="email@example.com" />
        </UiControl>
      </div>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Campaign Details
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="ppc-budget" label="Monthly Ad Budget">
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">$</span>
            <UiInput v-model="form.monthly_ad_budget" type="number" placeholder="0" class="pl-7" />
          </div>
        </UiControl>
        <UiControl id="ppc-geo" label="Target Geographic Area">
          <UiInput v-model="form.target_geographic_area" placeholder="e.g., Raleigh-Durham NC, 30mi radius" />
        </UiControl>
        <UiControl id="ppc-goal" label="Primary Goal">
          <UiSelect
            id="ppc-goal-select"
            v-model="form.primary_goal"
            :options="goalOptions"
          />
        </UiControl>
        <UiControl id="ppc-landing-pages" label="Landing Pages">
          <UiSelect
            id="ppc-landing-pages-select"
            v-model="form.landing_pages_status"
            :options="landingPageOptions"
          />
        </UiControl>
        <UiControl id="ppc-target-cpa" label="Target CPA or ROAS">
          <UiInput v-model="form.target_cpa_roas" placeholder="$45 per lead or 4x ROAS" />
        </UiControl>
        <UiControl id="ppc-volume-target" label="Monthly Lead/Sale Volume Target">
          <UiInput v-model="form.monthly_volume_target" type="number" placeholder="Optional" />
        </UiControl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'
import UiInput from '~/javascript/components/ui/form/input/input.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const goalOptions = [
  { id: 'lead_generation', title: 'Lead Generation' },
  { id: 'ecommerce_sales', title: 'E-commerce Sales' },
  { id: 'phone_calls', title: 'Phone Calls' },
  { id: 'store_visits', title: 'Store Visits' },
  { id: 'brand_awareness', title: 'Brand Awareness' }
]

const landingPageOptions = [
  { id: 'client_website', title: "Client's website" },
  { id: 'dedicated_existing', title: 'Dedicated landing pages already built' },
  { id: 'need_to_build', title: 'We need to build them' }
]

const form = ref({
  google_ads_account_id: '',
  existing_google_ads_email: '',
  monthly_ad_budget: '',
  target_geographic_area: '',
  primary_goal: '',
  landing_pages_status: '',
  target_cpa_roas: '',
  monthly_volume_target: ''
})

onMounted(() => {
  const d = props.onboarding.ppc_detail || {}
  form.value.google_ads_account_id = d.google_ads_account_id || ''
  form.value.existing_google_ads_email = d.existing_google_ads_email || ''
  form.value.monthly_ad_budget = d.monthly_ad_budget || ''
  form.value.target_geographic_area = d.target_geographic_area || ''
  form.value.primary_goal = d.primary_goal || ''
  form.value.landing_pages_status = d.landing_pages_status || ''
  form.value.target_cpa_roas = d.target_cpa_roas || ''
  form.value.monthly_volume_target = d.monthly_volume_target || ''
})

defineExpose({
  getData: () => ({ ...form.value })
})
</script>
